import PropTypes from 'prop-types';
import React from 'react';

import { Flexer, Icon, Tooltip } from '@ontruck/orc';
import { Logs } from 'modules/log';

const NumberOfIncidents = ({ number }) => (
  <Flexer.Parent alignItems="center">
    <Flexer.Child mRight="XS">{number}</Flexer.Child>
    <Flexer.Child>
      <Icon glyph="girded-exclamation" size="1.6rem" color="error500" />
    </Flexer.Child>
  </Flexer.Parent>
);

const IncidentsCell = ({
  journeyId,
  noTooltip,
  numberOfIncidents,
  shipper_orders_skin,
  className,
}) => {
  if (!numberOfIncidents) return null;

  return noTooltip ? (
    <NumberOfIncidents number={numberOfIncidents} />
  ) : (
    <Tooltip
      component={
        <Logs
          journeyId={journeyId}
          shipperOrdersSkin={shipper_orders_skin}
          showTitle={false}
          reduced
        />
      }
      tooltipClassName={className}
      position="bottom"
      skin="light"
    >
      <NumberOfIncidents number={numberOfIncidents} />
    </Tooltip>
  );
};

IncidentsCell.propTypes = {
  numberOfIncidents: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  shipper_orders_skin: PropTypes.shape({}),
};

export default IncidentsCell;
